import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { CARD_CHARGE_ERRORS } from 'constants/errors';

import { cardOnFile } from 'services/cardOnFile/cardOnFile';
import type {
  ChargeAttrs,
  ChargeResponse,
} from 'services/cardOnFile/cardOnFile';

export type ChargeError = (typeof CARD_CHARGE_ERRORS)[number];
export type ChargeErrorResponse = Error & {
  status?: number;
  parsedBody: {
    status: ChargeError;
  };
};

const useCharge = (): UseMutationResult<
  ChargeResponse,
  ChargeErrorResponse,
  ChargeAttrs
> =>
  useMutation<ChargeResponse, ChargeErrorResponse, ChargeAttrs>(attrs =>
    cardOnFile.charge(attrs),
  );

export { useCharge };
